import React, { useState } from 'react';
import './ModalForm.css';
import CloseIcon from './media/CloseIcon.png';

const ModalForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Обработка отправки формы
    console.log('Данные формы:', formData);
    // Здесь можно добавить логику отправки данных
    onClose(); // Закрываем модальное окно после отправки
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-form" onClick={onClose}>
      <div className="modal-form" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <h3>Оставьте свои контакты</h3>
            <p>Мы перезвоним вам в ближайшее время</p>
          </div>
          <div className="close-icon" onClick={onClose}>
            <img src={CloseIcon} alt="Close" />
          </div>
        </div>

        <form className="modal-form-content" onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Ваше имя</label>
            <div className="input-frame">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Например, Евгений"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваш email</label>
            <div className="input-frame">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Например, example@mail.com"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваш телефон</label>
            <div className="input-frame">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Например, +7 (900) 123-45-67"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваше сообщение</label>
            <div className="input-frame textarea-frame">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Например, я хотел бы узнать больше о вашем продукте"
              />
            </div>
          </div>

          <div className="agreement">
            <input
              type="checkbox"
              id="modal-agreement"
              name="agreement"
              checked={formData.agreement}
              onChange={handleInputChange}
              className="agreement-checkbox"
            />
            <label htmlFor="modal-agreement">
              Я даю согласие на обработку моих персональных данных, указанных в этой веб-форме, на условиях, изложенных в Политике в отношении обработки персональных данных в Интернете, с которой я ознакомился
            </label>
          </div>

          <button type="submit" className="submit-button">
            Оставить заявку
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModalForm;